// 交通選項
export const transportOptions = [
  {
    id: 1,
    title: "高鐵到台中＋轉接駁",
    description: "適合中部出發旅客",
    icon: "🚄",
    duration: "約 3 小時",
    price: "NT$ 1,200",
    features: ["高鐵票", "接駁車", "行李運送"]
  },
  {
    id: 2,
    title: "台北搭台鐵直達花蓮",
    description: "4 小時直達，含預約代訂",
    icon: "🚃",
    duration: "約 4 小時",
    price: "NT$ 440",
    features: ["台鐵票", "座位預約", "行李空間"]
  },
  {
    id: 3,
    title: "松山飛花蓮",
    description: "飛行時間 1 小時，含接駁",
    icon: "✈️",
    duration: "約 1 小時",
    price: "NT$ 2,500",
    features: ["機票", "機場接駁", "快速抵達"]
  }
];

// 住宿選項 - 大幅增加
export const stayOptions = [
  // 海景住宿
  {
    id: 1,
    name: "七星潭海景小屋",
    price: "NT$ 1,200",
    type: "海景",
    tags: ["海景", "Wi-Fi", "工作桌", "廚房", "觀景台"],
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&h=300&fit=crop",
    description: "面海而居的溫馨小屋，提供絕佳的海景視野，距離七星潭僅5分鐘步行",
    features: ["數位游牧友善", "共用空間", "可月租"]
  },
  {
    id: 2,
    name: "太平洋海景公寓",
    price: "NT$ 1,800",
    type: "海景",
    tags: ["海景", "Wi-Fi", "工作桌", "健身房", "游泳池"],
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop",
    description: "現代化海景公寓，配備完善設施，享受太平洋的壯麗景色",
    features: ["數位游牧友善", "商務中心", "可月租"]
  },
  {
    id: 3,
    name: "海灣別墅",
    price: "NT$ 3,500",
    type: "海景",
    tags: ["海景", "Wi-Fi", "工作桌", "廚房", "停車場", "私人海灘"],
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    description: "豪華海灣別墅，擁有私人海灘和無敵海景，適合長期居住",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 4,
    name: "海景青旅",
    price: "NT$ 600",
    type: "海景",
    tags: ["海景", "Wi-Fi", "交誼廳", "廚房", "觀景台"],
    image: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=400&h=300&fit=crop",
    description: "經濟實惠的海景青旅，提供社交空間和絕佳海景",
    features: ["數位游牧友善", "共用空間", "可月租"]
  },

  // 山景住宿
  {
    id: 5,
    name: "太魯閣山景民宿",
    price: "NT$ 1,500",
    type: "山景",
    tags: ["山景", "Wi-Fi", "工作桌", "廚房", "觀景台"],
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    description: "位於太魯閣峽谷旁的寧靜民宿，享受山景和峽谷風光",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 6,
    name: "中央山脈度假屋",
    price: "NT$ 2,200",
    type: "山景",
    tags: ["山景", "Wi-Fi", "工作桌", "廚房", "停車場", "健行步道"],
    image: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=400&h=300&fit=crop",
    description: "中央山脈深處的度假屋，遠離塵囂，享受山林寧靜",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 7,
    name: "山景木屋",
    price: "NT$ 1,800",
    type: "山景",
    tags: ["山景", "Wi-Fi", "工作桌", "廚房", "觀景台", "露台"],
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&h=300&fit=crop",
    description: "溫馨的山景木屋，採用自然建材，與山林融為一體",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 8,
    name: "雲端山莊",
    price: "NT$ 2,800",
    type: "山景",
    tags: ["山景", "Wi-Fi", "工作桌", "餐廳", "SPA", "觀景台"],
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop",
    description: "高海拔山莊，雲霧繚繞，享受雲端生活體驗",
    features: ["數位游牧友善", "商務中心", "可月租"]
  },

  // 市區住宿
  {
    id: 9,
    name: "花蓮市區飯店",
    price: "NT$ 2,500",
    type: "市區",
    tags: ["市區", "Wi-Fi", "健身房", "餐廳", "商務中心"],
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop",
    description: "五星級飯店服務，位於市中心，交通便利",
    features: ["數位游牧友善", "商務中心", "可月租"]
  },
  {
    id: 10,
    name: "文創園區公寓",
    price: "NT$ 1,600",
    type: "市區",
    tags: ["市區", "Wi-Fi", "工作桌", "廚房", "文創氛圍"],
    image: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=400&h=300&fit=crop",
    description: "位於花蓮文創園區內的現代公寓，充滿藝術氛圍",
    features: ["數位游牧友善", "共用空間", "可月租"]
  },
  {
    id: 11,
    name: "市區青旅",
    price: "NT$ 800",
    type: "市區",
    tags: ["市區", "Wi-Fi", "交誼廳", "廚房", "便利商店"],
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&h=300&fit=crop",
    description: "市中心的現代化青旅，提供舒適的住宿環境",
    features: ["數位游牧友善", "共用空間", "可月租"]
  },
  {
    id: 12,
    name: "商務公寓",
    price: "NT$ 1,900",
    type: "市區",
    tags: ["市區", "Wi-Fi", "工作桌", "廚房", "停車場", "健身房"],
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    description: "專為商務人士設計的公寓，配備完善的工作設施",
    features: ["數位游牧友善", "商務中心", "可月租"]
  },

  // 鄉村住宿
  {
    id: 13,
    name: "鄉村民宿",
    price: "NT$ 1,500",
    type: "鄉村",
    tags: ["鄉村", "Wi-Fi", "觀景台", "停車場", "農場體驗"],
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    description: "鄰近太魯閣峽谷的寧靜民宿，享受大自然的懷抱",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 14,
    name: "農場小屋",
    price: "NT$ 1,200",
    type: "鄉村",
    tags: ["鄉村", "Wi-Fi", "工作桌", "廚房", "農場體驗", "有機食材"],
    image: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=400&h=300&fit=crop",
    description: "有機農場內的小屋，體驗農村生活，享用新鮮食材",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 15,
    name: "茶園民宿",
    price: "NT$ 1,800",
    type: "鄉村",
    tags: ["鄉村", "Wi-Fi", "工作桌", "茶園體驗", "觀景台"],
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&h=300&fit=crop",
    description: "位於茶園中的民宿，享受茶香和山景，體驗茶文化",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 16,
    name: "森林木屋",
    price: "NT$ 2,000",
    type: "鄉村",
    tags: ["鄉村", "Wi-Fi", "工作桌", "森林浴", "健行步道"],
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    description: "森林深處的木屋，享受森林浴和自然療癒",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },

  // 特色住宿
  {
    id: 17,
    name: "溫泉度假村",
    price: "NT$ 3,200",
    type: "鄉村",
    tags: ["溫泉", "Wi-Fi", "工作桌", "SPA", "餐廳", "停車場"],
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop",
    description: "花蓮溫泉度假村，享受溫泉療癒和豪華設施",
    features: ["數位游牧友善", "商務中心", "可月租"]
  },
  {
    id: 18,
    name: "海濱露營車",
    price: "NT$ 900",
    type: "海景",
    tags: ["海景", "Wi-Fi", "露營車", "戶外廚房", "海灘"],
    image: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=400&h=300&fit=crop",
    description: "海濱露營車體驗，享受海風和星空",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 19,
    name: "樹屋民宿",
    price: "NT$ 1,600",
    type: "鄉村",
    tags: ["樹屋", "Wi-Fi", "工作桌", "森林景觀", "觀景台"],
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&h=300&fit=crop",
    description: "獨特的樹屋體驗，在樹上工作和休息",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },
  {
    id: 20,
    name: "玻璃屋",
    price: "NT$ 2,500",
    type: "山景",
    tags: ["玻璃屋", "Wi-Fi", "工作桌", "全景景觀", "觀景台"],
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    description: "全玻璃設計的住宿，享受360度全景景觀",
    features: ["數位游牧友善", "戶外空間", "可月租"]
  },

  // 豪華住宿
  {
    id: 21,
    name: "海景別墅",
    price: "NT$ 5,000",
    type: "海景",
    tags: ["海景", "Wi-Fi", "工作桌", "私人泳池", "管家服務", "停車場"],
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop",
    description: "豪華海景別墅，配備私人泳池和管家服務",
    features: ["數位游牧友善", "商務中心", "可月租"]
  },
  {
    id: 22,
    name: "山頂莊園",
    price: "NT$ 4,500",
    type: "山景",
    tags: ["山景", "Wi-Fi", "工作桌", "私人花園", "SPA", "餐廳"],
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=400&h=300&fit=crop",
    description: "山頂豪華莊園，享受私密和奢華的山居生活",
    features: ["數位游牧友善", "商務中心", "可月租"]
  },

  // 經濟型住宿
  {
    id: 23,
    name: "背包客棧",
    price: "NT$ 400",
    type: "市區",
    tags: ["背包客棧", "Wi-Fi", "交誼廳", "廚房", "便利商店"],
    image: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=400&h=300&fit=crop",
    description: "經濟實惠的背包客棧，適合預算有限的旅客",
    features: ["數位游牧友善", "共用空間", "可月租"]
  },
  {
    id: 24,
    name: "學生宿舍",
    price: "NT$ 300",
    type: "市區",
    tags: ["學生宿舍", "Wi-Fi", "工作桌", "共用廚房", "圖書館"],
    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&h=300&fit=crop",
    description: "學生宿舍式住宿，價格實惠，環境安靜",
    features: ["數位游牧友善", "共用空間", "可月租"]
  }
];

// 工作空間選項 - 大幅增加
export const workspaceOptions = [
  // 市中心工作空間
  {
    id: 1,
    name: "花蓮數位工作坊",
    price: "NT$ 300/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "位於市中心的現代化共用工作空間，交通便利",
    features: {
      wifi: "100Mbps",
      desks: 25,
      coffee: true,
      hours: "24/7",
      meeting: true
    },
    pricing: {
      daily: 300,
      weekly: 1500,
      monthly: 5000
    }
  },
  {
    id: 2,
    name: "文創園區工作坊",
    price: "NT$ 200/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "位於花蓮文創園區內，充滿藝術氛圍",
    features: {
      wifi: "80Mbps",
      desks: 20,
      coffee: true,
      hours: "09:00-21:00",
      meeting: true
    },
    pricing: {
      daily: 200,
      weekly: 1000,
      monthly: 3500
    }
  },
  {
    id: 3,
    name: "商務中心工作空間",
    price: "NT$ 400/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "專業商務中心，提供完整的商務服務",
    features: {
      wifi: "200Mbps",
      desks: 30,
      coffee: true,
      hours: "08:00-22:00",
      meeting: true
    },
    pricing: {
      daily: 400,
      weekly: 2000,
      monthly: 7000
    }
  },

  // 海景工作空間
  {
    id: 4,
    name: "海景工作空間",
    price: "NT$ 250/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "面海的工作空間，提供絕佳的海景視野",
    features: {
      wifi: "50Mbps",
      desks: 15,
      coffee: true,
      hours: "08:00-22:00",
      meeting: false
    },
    pricing: {
      daily: 250,
      weekly: 1200,
      monthly: 4000
    }
  },
  {
    id: 5,
    name: "七星潭海景工作室",
    price: "NT$ 350/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "七星潭旁的海景工作室，享受海風和寧靜",
    features: {
      wifi: "100Mbps",
      desks: 8,
      coffee: true,
      hours: "09:00-18:00",
      meeting: true
    },
    pricing: {
      daily: 350,
      weekly: 1800,
      monthly: 6000
    }
  },

  // 山景工作空間
  {
    id: 6,
    name: "山景靜心工作坊",
    price: "NT$ 280/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "山景環繞的寧靜工作空間，適合深度思考",
    features: {
      wifi: "60Mbps",
      desks: 12,
      coffee: true,
      hours: "08:00-20:00",
      meeting: false
    },
    pricing: {
      daily: 280,
      weekly: 1400,
      monthly: 4500
    }
  },
  {
    id: 7,
    name: "太魯閣峽谷工作空間",
    price: "NT$ 320/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "太魯閣峽谷旁的工作空間，享受壯麗山景",
    features: {
      wifi: "80Mbps",
      desks: 10,
      coffee: true,
      hours: "09:00-19:00",
      meeting: true
    },
    pricing: {
      daily: 320,
      weekly: 1600,
      monthly: 5200
    }
  },

  // 特色工作空間
  {
    id: 8,
    name: "咖啡廳工作空間",
    price: "NT$ 150/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "溫馨咖啡廳風格的工作空間，提供免費咖啡",
    features: {
      wifi: "50Mbps",
      desks: 18,
      coffee: true,
      hours: "07:00-23:00",
      meeting: false
    },
    pricing: {
      daily: 150,
      weekly: 750,
      monthly: 2500
    }
  },
  {
    id: 9,
    name: "圖書館工作空間",
    price: "NT$ 100/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "安靜的圖書館環境，適合需要專注的工作",
    features: {
      wifi: "40Mbps",
      desks: 25,
      coffee: false,
      hours: "08:00-21:00",
      meeting: false
    },
    pricing: {
      daily: 100,
      weekly: 500,
      monthly: 1800
    }
  },
  {
    id: 10,
    name: "戶外工作空間",
    price: "NT$ 180/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "戶外露台工作空間，享受自然光和新鮮空氣",
    features: {
      wifi: "60Mbps",
      desks: 15,
      coffee: true,
      hours: "08:00-18:00",
      meeting: false
    },
    pricing: {
      daily: 180,
      weekly: 900,
      monthly: 3000
    }
  },

  // 豪華工作空間
  {
    id: 11,
    name: "豪華商務工作坊",
    price: "NT$ 600/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "豪華商務環境，配備頂級設施和服務",
    features: {
      wifi: "500Mbps",
      desks: 40,
      coffee: true,
      hours: "24/7",
      meeting: true
    },
    pricing: {
      daily: 600,
      weekly: 3000,
      monthly: 10000
    }
  },
  {
    id: 12,
    name: "私人辦公室",
    price: "NT$ 800/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "獨立私人辦公室，提供完全的隱私和專注",
    features: {
      wifi: "200Mbps",
      desks: 1,
      coffee: true,
      hours: "24/7",
      meeting: true
    },
    pricing: {
      daily: 800,
      weekly: 4000,
      monthly: 12000
    }
  },

  // 經濟型工作空間
  {
    id: 13,
    name: "學生工作空間",
    price: "NT$ 80/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "專為學生設計的經濟型工作空間",
    features: {
      wifi: "30Mbps",
      desks: 35,
      coffee: false,
      hours: "09:00-22:00",
      meeting: false
    },
    pricing: {
      daily: 80,
      weekly: 400,
      monthly: 1500
    }
  },
  {
    id: 14,
    name: "社區工作空間",
    price: "NT$ 120/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "社區型工作空間，營造溫馨的社群氛圍",
    features: {
      wifi: "50Mbps",
      desks: 20,
      coffee: true,
      hours: "08:00-20:00",
      meeting: true
    },
    pricing: {
      daily: 120,
      weekly: 600,
      monthly: 2000
    }
  },

  // 特色主題工作空間
  {
    id: 15,
    name: "藝術家工作室",
    price: "NT$ 220/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "專為創作者設計的藝術氛圍工作空間",
    features: {
      wifi: "80Mbps",
      desks: 12,
      coffee: true,
      hours: "10:00-22:00",
      meeting: true
    },
    pricing: {
      daily: 220,
      weekly: 1100,
      monthly: 3500
    }
  },
  {
    id: 16,
    name: "科技工作坊",
    price: "NT$ 350/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "配備最新科技設備的專業工作空間",
    features: {
      wifi: "300Mbps",
      desks: 15,
      coffee: true,
      hours: "24/7",
      meeting: true
    },
    pricing: {
      daily: 350,
      weekly: 1750,
      monthly: 5500
    }
  },
  {
    id: 17,
    name: "靜修工作空間",
    price: "NT$ 200/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "禪意風格的靜修工作空間，適合冥想和創作",
    features: {
      wifi: "40Mbps",
      desks: 8,
      coffee: false,
      hours: "07:00-19:00",
      meeting: false
    },
    pricing: {
      daily: 200,
      weekly: 1000,
      monthly: 3200
    }
  },
  {
    id: 18,
    name: "創業孵化器",
    price: "NT$ 280/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "專為創業者設計的工作空間，提供創業資源",
    features: {
      wifi: "150Mbps",
      desks: 25,
      coffee: true,
      hours: "08:00-22:00",
      meeting: true
    },
    pricing: {
      daily: 280,
      weekly: 1400,
      monthly: 4500
    }
  },

  // 24小時工作空間
  {
    id: 19,
    name: "24小時工作空間",
    price: "NT$ 400/日",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=400&h=300&fit=crop",
    description: "24小時開放的工作空間，適合夜貓子工作者",
    features: {
      wifi: "200Mbps",
      desks: 30,
      coffee: true,
      hours: "24/7",
      meeting: true
    },
    pricing: {
      daily: 400,
      weekly: 2000,
      monthly: 6500
    }
  },
  {
    id: 20,
    name: "夜間工作坊",
    price: "NT$ 180/日",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop",
    description: "專為夜間工作者設計的安靜工作環境",
    features: {
      wifi: "100Mbps",
      desks: 20,
      coffee: true,
      hours: "18:00-06:00",
      meeting: false
    },
    pricing: {
      daily: 180,
      weekly: 900,
      monthly: 3000
    }
  }
];

// 社群活動選項
export const communityOptions = [
  {
    id: 1,
    name: "語言交換之夜",
    type: "語言",
    time: "每週三 19:00-21:00",
    language: "中英文",
    free: true,
    icon: "🗣️",
    description: "中英文語言交換活動，提升語言能力同時認識國際朋友",
    location: "海景工作空間"
  },
  {
    id: 2,
    name: "攝影工作坊",
    type: "藝術",
    time: "每週六 14:00-17:00",
    language: "中文",
    free: false,
    price: "NT$ 500",
    icon: "📸",
    description: "學習攝影技巧，捕捉花蓮的美麗風景",
    location: "七星潭"
  },
  {
    id: 3,
    name: "瑜珈課",
    type: "運動",
    time: "每週二、四 18:00-19:00",
    language: "中文",
    free: false,
    price: "NT$ 300",
    icon: "🧘‍♀️",
    description: "專業瑜珈老師指導，放鬆身心",
    location: "文創園區"
  },
  {
    id: 4,
    name: "數位游牧聚會",
    type: "社交",
    time: "每月第一個週五 19:00-21:00",
    language: "中英文",
    free: true,
    icon: "👥",
    description: "數位游牧者聚會，分享工作經驗和交流",
    location: "花蓮數位工作坊"
  },
  {
    id: 5,
    name: "健行團",
    type: "戶外",
    time: "每週日 08:00-16:00",
    language: "中文",
    free: false,
    price: "NT$ 800",
    icon: "🏃‍♂️",
    description: "週末一起到太魯閣健行，欣賞美麗的自然風景",
    location: "太魯閣國家公園"
  }
]; 